import { render, staticRenderFns } from "./integral-order-detail.vue?vue&type=template&id=501b1518&scoped=true&"
import script from "./integral-order-detail.vue?vue&type=script&lang=js&"
export * from "./integral-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./integral-order-detail.vue?vue&type=style&index=0&id=501b1518&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b1518",
  null
  
)

export default component.exports